<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    direction="ltr"
    size="600px"
    @closed="handleClosed"
  >
    <el-form label-position="top" size="small" style="padding: 0 20px; box-sizing: border-box">
      <el-row
        :gutter="10" justify="left" style="flex-wrap: wrap"
        type="flex"
      >
        <el-col :span="12">
          <!--定责环节-->
          <el-form-item :label="$t('fixDutyFine.DefiniteLink')">
            <el-select
              v-model="localParams.responsibilityStageList"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in responsibilityTypeList.responsibility_stage"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--定责状态-->
          <el-form-item :label="$t('vehicle.responsibilityStatus')">
            <el-select
              v-model="localParams.statusList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              style="width: 100%"
            >
              <el-option :label="$t('home.pendingConfirmation')" :value="2" />
              <el-option :label="$t('vehicle.inReconciliation')" :value="3" />
              <el-option :label="$t('vehicle.pushedToFinance')" :value="4" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--责任方-->
          <el-form-item :label="$t('fixDutyFine.ResponsibleParty')">
            <el-select
              v-model="localParams.responsibilityParty"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              style="width: 100%"
            >
              <el-option key="1" :label="$t('fixDutyFine.trunkLine')" :value="1" />
              <el-option key="2" :label="$t('orderCenterCont.region')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--大区-->
          <el-form-item :label="$t('collectionCenter.region')">
            <el-select
              v-model="localParams.regionId"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--网点所属州-->
          <el-form-item :label="$t('collectionCenter.stateSite1')">
            <el-select
              v-model="localParams.stateList"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.twoCode"
                :label="item.twoCode"
                :value="item.twoCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--所属转运中心-->
          <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
            <el-select
              v-model="localParams.transitCenterIdList"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in transitCenterOptionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--客户-->
          <el-form-item :label="$t('collectionCenter.client')">
            <el-select
              v-model="localParams.customerIdList"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @change="handleCustomerChange"
              @clear="getCustomerPage('')"
              @focus="getCustomerPage('', true)"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--商户-->
          <el-form-item :label="$t('collectionCenter.CommercialOwner')">
            <el-select
              v-model="localParams.merchantCodeList"
              :disabled="!localParams.customerIdList || localParams.customerIdList.length === 0"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
              @change="handleMerchantChange"
            >
              <el-option
                v-for="(item, index) in merchantList"
                :key="index"
                :label="item.merchantName + '（' + item.merchantCode + '）'"
                :value="item.merchantCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 标签 -->
          <el-form-item :label="$t('navbar.tag')" style="width: 100%">
            <el-select
              v-model="localParams.lostType"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option key="all" :label="$t('operationTips.packageConfirmedLost')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 扣款状态 -->
          <el-form-item :label="$t('ClaimsManagement.deductionStatus')" style="width: 100%">
            <el-select
              v-model="localParams.fineStatus"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option key="1" :label="$t('GlobalSetObj.yes')" :value="1" />
              <el-option key="2" :label="$t('GlobalSetObj.No')" :value="0" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
      <el-button size="small" type="primary" @click="handleSearch">{{ $t('newOrder.search') }}
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep';
import { getMerchantByCustomerIdList } from '@/api/orderApi';
import { apiCustomerPage } from '@/api/customer';

const DEFAULT_PARAMS = {
  responsibilityStageList: [],
  statusList: [],
  responsibilityParty: '',
  regionId: '',
  stateList: [],
  transitCenterIdList: [],
  customerIdList: [],
  // 客户名称：仅用于父组件"已选条件"回显（会随 search 事件一并返回，后端不识别该字段）
  customerNameList: [],
  merchantCodeList: [],
  // 商户名称：仅用于父组件"已选条件"回显（同上）
  merchantNameList: [],
  lostType: null,
  fineStatus: null
};

export default {
  name: 'SearchCom',
  props: {
    responsibilityTypeList: {
      type: Object,
      default: () => ({})
    },
    regionList: {
      type: Array,
      default: () => []
    },
    stateOptionList: {
      type: Array,
      default: () => []
    },
    transitCenterOptionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchDrawer: false,
      localParams: cloneDeep(DEFAULT_PARAMS),
      stateOptions: [],
      customerList: [],
      merchantList: [],
      // 名称缓存：远程搜索会覆盖 customerList / merchantList，用 map 累积保证"已选条件"能回显名称
      customerNameMap: {},
      merchantNameMap: {}
    };
  },
  watch: {
    'localParams.regionId'(newVal) {
      this.localParams.stateList = [];
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateOptions = selectedRegion.states.map((twoCode) => ({ twoCode }));
          return;
        }
      }
      this.stateOptions = [...this.stateOptionList];
    }
  },
  methods: {
    showDialog() {
      // 按当前大区同步州选项：大区未选时显示全部州
      if (this.localParams.regionId) {
        const selectedRegion = this.regionList.find((item) => item.id === this.localParams.regionId);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateOptions = selectedRegion.states.map((twoCode) => ({ twoCode }));
        } else {
          this.stateOptions = [...this.stateOptionList];
        }
      } else {
        this.stateOptions = [...this.stateOptionList];
      }
      // 未选客户时清空商户选项列表
      if (!this.localParams.customerIdList || this.localParams.customerIdList.length === 0) {
        this.merchantList = [];
      }
      this.searchDrawer = true;
    },
    handleSearch() {
      // 提交前同步一次展示名称，保证父组件"已选条件"能正确回显客户/商户
      this.syncSelectedNames();
      this.$emit('search', cloneDeep(this.localParams));
      this.searchDrawer = false;
    },
    handleReset() {
      this.localParams = cloneDeep(DEFAULT_PARAMS);
      this.customerList = [];
      this.merchantList = [];
    },
    // 提供给父组件：获取当前选中的查询条件（未点搜索直接关闭也能生效）
    getLocalParams() {
      return cloneDeep(this.localParams);
    },
    // 提供给父组件"已选条件"：移除单个条件，清空抽屉内对应条件并返回最新条件
    removeLocalParam(key) {
      const current = this.localParams[key];
      // 数组类条件重置为空数组，其余（大区/责任方/标签/扣款状态）重置为默认值
      this.localParams[key] = Array.isArray(current) ? [] : DEFAULT_PARAMS[key];
      // 大区被移除时需同步清空州，避免残留没有归属的州条件
      if (key === 'regionId') {
        this.localParams.stateList = [];
      }
      // 客户被移除时需同步清空商户（商户选项依赖客户）
      if (key === 'customerIdList') {
        this.localParams.merchantCodeList = [];
        this.merchantList = [];
      }
      this.syncSelectedNames();
      return cloneDeep(this.localParams);
    },
    // 提供给父组件"清空全部"：清空抽屉内全部高级搜索条件并返回最新条件
    clearLocalParams() {
      this.handleReset();
      return cloneDeep(this.localParams);
    },
    handleClosed() {
      // 抽屉关闭时不做额外操作
    },
    // 客户变更：刷新商户选项（商户依赖客户）并同步已选客户名称
    handleCustomerChange(val) {
      this.getMerchantList(val);
      this.syncSelectedNames();
    },
    // 商户变更：同步已选商户名称
    handleMerchantChange() {
      this.syncSelectedNames();
    },
    // 依据已选的客户 id / 商户编码同步展示名称，供父组件"已选条件"回显（取不到时回退为 id/code）
    syncSelectedNames() {
      this.localParams.customerNameList = (this.localParams.customerIdList || []).map(
        (id) => this.customerNameMap[id] || id
      );
      this.localParams.merchantNameList = (this.localParams.merchantCodeList || []).map(
        (code) => this.merchantNameMap[code] || code
      );
    },
    // 商户联动
    getMerchantList(val) {
      if (!val || val.length === 0) {
        this.localParams.merchantCodeList = [];
        this.localParams.merchantNameList = [];
        this.merchantList = [];
        return;
      }
      const form = {
        customerIdList: val
      };
      getMerchantByCustomerIdList(form).then((res) => {
        if (res.code === 200) {
          this.merchantList = res.data;
          // 缓存商户编码与名称的映射，供"已选条件"回显
          res.data.forEach((item) => {
            this.merchantNameMap[item.merchantCode] =
              item.merchantName + '（' + item.merchantCode + '）';
          });
        }
      });
    },
    // 缓存客户 id 与名称的映射，供"已选条件"回显（名称与下拉选项 label 保持一致）
    cacheCustomerNames(records) {
      (records || []).forEach((item) => {
        this.customerNameMap[item.id] = item.username;
      });
    },
    // 客户远程搜索
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = res.data.records;
              this.cacheCustomerNames(res.data.records);
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records;
            this.cacheCustomerNames(res.data.records);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}
</style>
